import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SchedulesComments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      data_schedule_grade_comments: [],
    };
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.data_schedule_grade_comments !== 'undefined') {
      this.setState({
        data_schedule_grade_comments: newProps.data_schedule_grade_comments,
        loaded: 1,
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4 className="pull-left">Comentários</h4>
  <div className="clearfix"></div>
  <hr/>
  <BootstrapTable data={self.state.data_schedule_grade_comments} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há férias'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn isKey={true} dataField="schedule" width='30' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Escala</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" width='30' dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
    <TableHeaderColumn dataField="schedule_grade" width='30' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>
    <TableHeaderColumn dataField="number" width='20' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Revisão</TableHeaderColumn>
    <TableHeaderColumn dataField="text" width='200' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Texto</TableHeaderColumn>
  </BootstrapTable> 
</div>
    );
  }
}

export default SchedulesComments;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesComments.js